/* ========================================================================
   General
 ========================================================================== */

app.general = (function () {
  'use strict';

  // function initEmailLinks() {
  //   // Handle base-64 encoded mailto-links
  //   const links = document.querySelectorAll('a[data-email]');

  //   links.forEach((el) => {
  //     el.addEventListener('click', (event) => {
  //       let email = atob(el.getAttribute('data-email'));
  //       window.location.href = 'mailto:' + email;
  //     });
  //   });
  // }

  // function initLax() {
  //   lax.init();

  //   // Add a driver that we use to control our animations
  //   lax.addDriver('scrollY', function () {
  //     return window.scrollY;
  //   });

  //   lax.addElements('[data-lax]]', {
  //     scrollY: {
  //       translateY: [
  //         ['elInY', 'elOutY'],
  //         [0, -250],
  //       ],
  //     },
  //   });
  // }

  const updateAppHeight = util.debounce(() => {
    document.documentElement.style.setProperty(
      '--app-height',
      window.innerHeight + 'px'
    );
  }, 250);

  function initAppHeight() {
    // Init app height
    updateAppHeight();

    // Handle app height on resize
    window.addEventListener(
      'resize',
      () => {
        updateAppHeight();
      },
      { passive: true }
    );
  }

  // let isTouch = false;
  // let isTouchClass = 'is-touch';
  // let isTouchTimer;

  // function addTouchClass() {
  //   window.clearTimeout(isTouchTimer);
  //   if (isTouch === true) return;

  //   isTouchTimer = window.setTimeout(() => {
  //     document.documentElement.classList.add(isTouchClass);
  //     isTouch = true;
  //   }, 250);
  // }

  // function removeTouchClass() {
  //   if (isTouch === false) return;

  //   document.documentElement.classList.remove(isTouchClass);
  //   isTouch = false;
  // }

  // function initTouch() {
  //   document.addEventListener('touchstart', addTouchClass, { passive: true });
  //   document.addEventListener('mouseover', removeTouchClass);
  // }

  // Expose public functions and variables
  return {
    // initEmailLinks: initEmailLinks,
    // initLax: initLax,
    initAppHeight: initAppHeight,
    updateAppHeight: updateAppHeight,
    // initTouch: initTouch,
  };
})();
